import React from "react";
import { Message, Transition } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import ToastMessageStore from "~/stores/ToastMessageStore";
import "./styles/ToastMessageContainer.less";

@observer
class ToastMessageContainer extends React.Component {
  render() {
    const { toastMessageStore } = this.props;
    const { toastMessages } = toastMessageStore;

    if (toastMessages.length === 0) {
      return null;
    }

    return (
      <div className="toast-message-container">
        {toastMessages.map(toastMessage => (
          <Transition
            key={toastMessage.id}
            visible={toastMessage.visible}
            animation="fly left"
            duration={500}
            unmountOnHide
          >
            <Message
              onDismiss={() => toastMessageStore.hideToastMessage(toastMessage.id)}
              info={toastMessage.type === "info"}
              warning={toastMessage.type === "warning"}
              positive={toastMessage.type === "positive"}
              negative={toastMessage.type === "negative"}
            >
              <Message.Content>
                {toastMessage.header && <Message.Header>{toastMessage.header}</Message.Header>}
                <p>{toastMessage.message}</p>
              </Message.Content>
            </Message>
          </Transition>
        ))}
      </div>
    );
  }
}

ToastMessageContainer.propTypes = {
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default ToastMessageContainer;
